/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AtualizarTutorDto,
  CriarTutorDto,
  ErroResponse,
  PaginaDeTutoresResponse,
  TutorResponse,
  TutoresControllerListarParams
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getTutoresControllerListarUrl = (params?: TutoresControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/tutores?${stringifiedParams}` : `/v1/tutores`
}

/**
 * @summary Lista os tutores do ambiente da sessão, paginado
 */
export const tutoresControllerListar = async (params?: TutoresControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeTutoresResponse> => {

  return httpClient<PaginaDeTutoresResponse>(getTutoresControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTutoresControllerListarQueryKey = (params?: TutoresControllerListarParams,) => {
    return [
    `/v1/tutores`, ...(params ? [params] : [])
    ] as const;
    }


export const getTutoresControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof tutoresControllerListar>>, TError = ErroResponse>(params?: TutoresControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTutoresControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tutoresControllerListar>>> = ({ signal }) => tutoresControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TutoresControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof tutoresControllerListar>>>
export type TutoresControllerListarQueryError = ErroResponse


export function useTutoresControllerListar<TData = Awaited<ReturnType<typeof tutoresControllerListar>>, TError = ErroResponse>(
 params: undefined |  TutoresControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tutoresControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tutoresControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTutoresControllerListar<TData = Awaited<ReturnType<typeof tutoresControllerListar>>, TError = ErroResponse>(
 params?: TutoresControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tutoresControllerListar>>,
          TError,
          Awaited<ReturnType<typeof tutoresControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTutoresControllerListar<TData = Awaited<ReturnType<typeof tutoresControllerListar>>, TError = ErroResponse>(
 params?: TutoresControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista os tutores do ambiente da sessão, paginado
 */

export function useTutoresControllerListar<TData = Awaited<ReturnType<typeof tutoresControllerListar>>, TError = ErroResponse>(
 params?: TutoresControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTutoresControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTutoresControllerCriarUrl = () => {




  return `/v1/tutores`
}

/**
 * @summary Cadastra um tutor no ambiente da sessão
 */
export const tutoresControllerCriar = async (criarTutorDto: CriarTutorDto, options?: Parameters<typeof httpClient>[1]): Promise<TutorResponse> => {

  return httpClient<TutorResponse>(getTutoresControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarTutorDto)
  }
);}





export const getTutoresControllerCriarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerCriar>>, TError,{data: CriarTutorDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerCriar>>, TError,{data: CriarTutorDto}, TContext> => {

const mutationKey = ['tutoresControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tutoresControllerCriar>>, {data: CriarTutorDto}> = (props) => {
          const {data} = props ?? {};

          return  tutoresControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TutoresControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof tutoresControllerCriar>>>
    export type TutoresControllerCriarMutationBody = CriarTutorDto
    export type TutoresControllerCriarMutationError = unknown

    /**
 * @summary Cadastra um tutor no ambiente da sessão
 */
export const useTutoresControllerCriar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerCriar>>, TError,{data: CriarTutorDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tutoresControllerCriar>>,
        TError,
        {data: CriarTutorDto},
        TContext
      > => {
      return useMutation(getTutoresControllerCriarMutationOptions(options), queryClient);
    }
    export const getTutoresControllerObterUrl = (id: string,) => {




  return `/v1/tutores/${id}`
}

/**
 * @summary Detalha um tutor
 */
export const tutoresControllerObter = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<TutorResponse> => {

  return httpClient<TutorResponse>(getTutoresControllerObterUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getTutoresControllerObterQueryKey = (id: string,) => {
    return [
    `/v1/tutores/${id}`
    ] as const;
    }


export const getTutoresControllerObterQueryOptions = <TData = Awaited<ReturnType<typeof tutoresControllerObter>>, TError = ErroResponse>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTutoresControllerObterQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof tutoresControllerObter>>> = ({ signal }) => tutoresControllerObter(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerObter>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type TutoresControllerObterQueryResult = NonNullable<Awaited<ReturnType<typeof tutoresControllerObter>>>
export type TutoresControllerObterQueryError = ErroResponse


export function useTutoresControllerObter<TData = Awaited<ReturnType<typeof tutoresControllerObter>>, TError = ErroResponse>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerObter>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tutoresControllerObter>>,
          TError,
          Awaited<ReturnType<typeof tutoresControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTutoresControllerObter<TData = Awaited<ReturnType<typeof tutoresControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerObter>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tutoresControllerObter>>,
          TError,
          Awaited<ReturnType<typeof tutoresControllerObter>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useTutoresControllerObter<TData = Awaited<ReturnType<typeof tutoresControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Detalha um tutor
 */

export function useTutoresControllerObter<TData = Awaited<ReturnType<typeof tutoresControllerObter>>, TError = ErroResponse>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tutoresControllerObter>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getTutoresControllerObterQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getTutoresControllerAtualizarUrl = (id: string,) => {




  return `/v1/tutores/${id}`
}

/**
 * @summary Edita parcialmente. Campo omitido fica como está; `null` apaga o valor.
 */
export const tutoresControllerAtualizar = async (id: string,
    atualizarTutorDto: AtualizarTutorDto, options?: Parameters<typeof httpClient>[1]): Promise<TutorResponse> => {

  return httpClient<TutorResponse>(getTutoresControllerAtualizarUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarTutorDto)
  }
);}





export const getTutoresControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerAtualizar>>, TError,{id: string;data: AtualizarTutorDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerAtualizar>>, TError,{id: string;data: AtualizarTutorDto}, TContext> => {

const mutationKey = ['tutoresControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tutoresControllerAtualizar>>, {id: string;data: AtualizarTutorDto}> = (props) => {
          const {id,data} = props ?? {};

          return  tutoresControllerAtualizar(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TutoresControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof tutoresControllerAtualizar>>>
    export type TutoresControllerAtualizarMutationBody = AtualizarTutorDto
    export type TutoresControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita parcialmente. Campo omitido fica como está; `null` apaga o valor.
 */
export const useTutoresControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerAtualizar>>, TError,{id: string;data: AtualizarTutorDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tutoresControllerAtualizar>>,
        TError,
        {id: string;data: AtualizarTutorDto},
        TContext
      > => {
      return useMutation(getTutoresControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getTutoresControllerExcluirUrl = (id: string,) => {




  return `/v1/tutores/${id}`
}

/**
 * @summary Exclusão lógica. O tutor sai das listagens e os pacientes mantêm a referência.
 */
export const tutoresControllerExcluir = async (id: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getTutoresControllerExcluirUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getTutoresControllerExcluirMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerExcluir>>, TError,{id: string}, TContext> => {

const mutationKey = ['tutoresControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof tutoresControllerExcluir>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  tutoresControllerExcluir(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type TutoresControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof tutoresControllerExcluir>>>

    export type TutoresControllerExcluirMutationError = ErroResponse

    /**
 * @summary Exclusão lógica. O tutor sai das listagens e os pacientes mantêm a referência.
 */
export const useTutoresControllerExcluir = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof tutoresControllerExcluir>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof tutoresControllerExcluir>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getTutoresControllerExcluirMutationOptions(options), queryClient);
    }
